const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  merchantId: state => state.user.merchantId,
  addRouters: state => state.permission.addRouters || [],
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js